/* LAMY Zine — tương tác trang chủ: chấm đánh số trên look, thêm vào giỏ, bàn Phối thử, vé chọn quà, hiện dần khi cuộn.
   Không dùng thư viện. Không có JavaScript thì mọi món vẫn là liên kết bình thường. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = function (cents) {
    return (Math.round(cents / 100)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + 'đ';
  };

  /* Thông báo nhỏ góc dưới */
  var toast;
  function say(html) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'lz-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.innerHTML = html;
    toast.classList.add('is-on');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 3600);
  }

  /* Thêm nhiều món vào giỏ rồi cập nhật số trên biểu tượng giỏ */
  function addItems(ids, btn) {
    if (!ids.length) return;
    var old = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Đang thêm…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
    }).then(function (r) {
      if (!r.ok) throw r;
      return fetch('/cart.js').then(function (c) { return c.json(); });
    }).then(function (cart) {
      document.querySelectorAll('.minicart-btn .notification, .mini-cart-wrap .notification, [data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
      say('Đã thêm ' + ids.length + ' món vào giỏ. <a href="/cart">Xem giỏ hàng →</a>');
      if (btn) { btn.textContent = 'Đã thêm ✓'; setTimeout(function () { btn.textContent = old; btn.disabled = false; }, 2200); }
    }).catch(function () {
      say('Chưa thêm được. Bạn thử lại hoặc mở trang sản phẩm nhé.');
      if (btn) { btn.textContent = old; btn.disabled = false; }
    });
  }

  /* Look: chấm ↔ dòng sản phẩm, thêm cả look */
  document.querySelectorAll('[data-lz-look]').forEach(function (look) {
    var flash = function (el) { el.classList.remove('is-flash'); void el.offsetWidth; el.classList.add('is-flash'); };
    look.querySelectorAll('.lz-hot').forEach(function (hot) {
      hot.addEventListener('click', function () {
        var row = look.querySelector('.lz-item[data-i="' + hot.dataset.i + '"]');
        if (!row) return;
        if (window.innerWidth < 1100) row.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        flash(row);
      });
    });
    look.querySelectorAll('.lz-item').forEach(function (row) {
      var hot = look.querySelector('.lz-hot[data-i="' + row.dataset.i + '"]');
      if (!hot) return;
      row.addEventListener('mouseenter', function () { hot.classList.add('is-on'); });
      row.addEventListener('mouseleave', function () { hot.classList.remove('is-on'); });
    });
    look.querySelectorAll('[data-add]').forEach(function (b) {
      b.addEventListener('click', function () { addItems([b.dataset.add], null); b.textContent = '✓'; });
    });
    var all = look.querySelector('[data-add-all]');
    if (all) all.addEventListener('click', function () {
      var ids = [].map.call(look.querySelectorAll('.lz-item[data-variant]'), function (r) { return r.dataset.variant; });
      addItems(ids, all);
    });
  });

  /* Bàn Phối thử */
  document.querySelectorAll('[data-lz-mix]').forEach(function (mix) {
    var picked = {};
    var sumEl = mix.querySelector('[data-mix-sum]');
    var addBtn = mix.querySelector('[data-mix-add]');
    var live = mix.querySelector('.lz-mix__picked');
    function render() {
      var n = 0, total = 0, names = [];
      mix.querySelectorAll('.lz-slot').forEach(function (slot) {
        var p = picked[slot.dataset.slot];
        var img = slot.querySelector('img');
        if (p) {
          img.src = p.dataset.img; img.alt = p.dataset.title; img.hidden = false;
          slot.classList.add('is-full');
          slot.classList.remove('is-drop'); void slot.offsetWidth; slot.classList.add('is-drop');
          n++; total += Number(p.dataset.price); names.push(p.dataset.title);
        } else { img.hidden = true; slot.classList.remove('is-full'); }
      });
      mix.querySelectorAll('.lz-pick').forEach(function (a) {
        a.setAttribute('aria-pressed', picked[a.dataset.slot] === a ? 'true' : 'false');
      });
      sumEl.textContent = n + ' món · ' + money(total);
      addBtn.disabled = n === 0;
      addBtn.textContent = n ? 'Thêm ' + n + ' món' : 'Thêm vào giỏ';
      live.textContent = names.join(' · ');
    }
    mix.querySelectorAll('.lz-pick').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        picked[a.dataset.slot] = picked[a.dataset.slot] === a ? null : a;
        render();
      });
    });
    mix.querySelectorAll('.lz-tab').forEach(function (t) {
      t.addEventListener('click', function () {
        mix.querySelectorAll('.lz-tab').forEach(function (x) { x.classList.toggle('is-on', x === t); x.setAttribute('aria-selected', x === t); });
        mix.querySelectorAll('.lz-row').forEach(function (r) { r.classList.toggle('is-on', r.dataset.row === t.dataset.tab); });
      });
    });
    function random() {
      ['neck', 'ear', 'wrist'].forEach(function (s) {
        var opts = mix.querySelectorAll('.lz-pick[data-slot="' + s + '"]');
        if (opts.length) picked[s] = opts[Math.floor(Math.random() * opts.length)];
      });
      render();
    }
    mix.querySelector('[data-mix-random]').addEventListener('click', random);
    addBtn.addEventListener('click', function () {
      var ids = Object.keys(picked).filter(function (k) { return picked[k]; }).map(function (k) { return picked[k].dataset.variant; });
      addItems(ids, addBtn);
    });
    /* Mở sẵn một bộ: món đầu tiên của mỗi hàng */
    ['neck', 'ear', 'wrist'].forEach(function (s) {
      var first = mix.querySelector('.lz-pick[data-slot="' + s + '"]');
      if (first) picked[s] = first;
    });
    render();
  });

  /* Bàn quà: vé người nhận */
  document.querySelectorAll('[data-lz-gift]').forEach(function (gift) {
    gift.querySelectorAll('.lz-ticket').forEach(function (t) {
      t.addEventListener('click', function () {
        gift.querySelectorAll('.lz-ticket').forEach(function (x) { x.classList.toggle('is-on', x === t); x.setAttribute('aria-pressed', x === t); });
        gift.querySelectorAll('.lz-gift__row').forEach(function (r) { r.classList.toggle('is-on', r.dataset.ticketRow === t.dataset.ticket); });
      });
    });
  });

  /* A+D: nút "+" trên thẻ sản phẩm và "Thêm cả look" */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-ad-add]') : null;
    if (!b) return;
    e.preventDefault();
    addItems([b.dataset.adAdd], null);
    b.classList.add('is-done');
    b.textContent = '✓';
  });
  document.querySelectorAll('[data-ad-look]').forEach(function (look) {
    var all = look.querySelector('[data-ad-add-all]');
    if (!all) return;
    all.addEventListener('click', function () {
      var ids = [].map.call(look.querySelectorAll('.ad-card[data-ad-variant]'), function (c) { return c.dataset.adVariant; });
      addItems(ids, all);
    });
  });

  /* LAMY Sang: xem thử font tiêu đề qua ?font=josefin|montserrat|inter (giữ trong phiên) */
  try {
    var fq = new URLSearchParams(location.search).get('font');
    if (fq) sessionStorage.setItem('lamy-font', fq);
    var fv = fq || sessionStorage.getItem('lamy-font');
    if (fv && fv !== 'josefin') document.documentElement.setAttribute('data-font', fv);
  } catch (err) {}

  /* LAMY Sang: ảnh bìa trình chiếu — số đếm, thanh chạy, tự chuyển 6 giây, dừng khi người dùng vuốt */
  document.querySelectorAll('[data-s-slides]').forEach(function (box) {
    var track = box.querySelector('[data-s-track]');
    var slides = track ? track.children : [];
    var count = box.querySelector('[data-s-count]');
    var bar = box.querySelector('[data-s-bar]');
    if (!track || slides.length < 2) return;
    var idx = 0, timer = null, paused = false;
    function pad(n) { return (n < 9 ? '0' : '') + (n + 1); }
    function runBar() {
      if (!bar) return;
      bar.classList.remove('is-run'); void bar.offsetWidth;
      if (!reduce && !paused) bar.classList.add('is-run');
    }
    function show(i) {
      idx = (i + slides.length) % slides.length;
      track.scrollTo({ left: idx * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    }
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i !== idx) { idx = i; }
      if (count) count.textContent = pad(idx);
    }, { passive: true });
    function loop() {
      clearInterval(timer);
      if (reduce) return;
      runBar();
      timer = setInterval(function () { if (!paused) { show(idx + 1); runBar(); } }, 6000);
    }
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
      track.addEventListener(ev, function () { paused = true; if (bar) bar.classList.remove('is-run'); clearTimeout(box._r); box._r = setTimeout(function () { paused = false; loop(); }, 9000); }, { passive: true });
    });
    loop();
  });

  /* LAMY Pastel: Quà cho người thương — chọn người nhận đổi câu gợi ý + sản phẩm */
  document.querySelectorAll('[data-p-gift]').forEach(function (g) {
    g.querySelectorAll('[data-p-tab]').forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        g.querySelectorAll('[data-p-tab]').forEach(function (x) { x.classList.toggle('is-on', x === t); x.setAttribute('aria-selected', x === t); });
        g.querySelectorAll('[data-p-panel]').forEach(function (p) { p.classList.toggle('is-on', p.dataset.pPanel === t.dataset.pTab); });
      });
    });
  });

  /* LAMY Sang: băng sản phẩm trượt — nút ‹ › trên máy tính */
  document.querySelectorAll('[data-s-rail]').forEach(function (rail) {
    var t = rail.querySelector('[data-s-rail-track]');
    if (!t) return;
    var go = function (d) { t.scrollBy({ left: d * t.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' }); };
    var p = rail.querySelector('[data-s-prev]'), n = rail.querySelector('[data-s-next]');
    if (p) p.addEventListener('click', function () { go(-1); });
    if (n) n.addEventListener('click', function () { go(1); });
  });

  /* Hiện dần khi cuộn tới */
  var els = document.querySelectorAll('.lz-reveal, .lz-stamps, .ad-reveal');
  if (!reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('lz-in'); io.unobserve(e.target); } });
    }, { threshold: 0.2 });
    els.forEach(function (el) { el.classList.add('lz-wait'); io.observe(el); });
  }
})();
